import { render, staticRenderFns } from "./price-request-item.vue?vue&type=template&id=34a3ffda"
import script from "./price-request-item.vue?vue&type=script&lang=js"
export * from "./price-request-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports